import { FEATURE_ASSIGNMENT_LIBRARY } from '../../core/features';
import programEvaluationSample from './assets/program-evaluation-sample.png';
import studentProgressSample from './assets/student-progress-sample.png';

export const DISTRICT_WIDE_DESCRIPTION =
  'District-wide evaluation: proficiency distribution, domain growth, exit projection, school-by-school, and subgroup findings.';

export type ReportCatalogEntry = {
  key: string;
  title: string;
  description: string;
  /** A fixed rendering of the report's first page, shown on the hub card. Sample data, never the district's. */
  coverSrc?: string;
  feature?: string;
};

export const STUDENT_PROGRESS_KEY = 'student-progress';
export const PROGRAM_EVALUATION_KEY = 'program-evaluation';
export const IMPLEMENTATION_KEY = 'implementation';
export const LIBRARY_KEY = 'assignment-library';

export type CatalogRole = { isSuperAdmin: boolean; isDistrictAdmin: boolean };

const noFeatures = () => false;

export function catalogForRole(
  catalog: ReportCatalogEntry[],
  role: CatalogRole,
  hasFeature: (key: string) => boolean = noFeatures,
): ReportCatalogEntry[] {
  const released = catalog.filter((report) => report.feature === undefined || hasFeature(report.feature));
  if (role.isSuperAdmin) return released;
  const tiles = released.filter((report) => report.key === STUDENT_PROGRESS_KEY);
  if (role.isDistrictAdmin) {
    tiles.push(...released.filter((report) => report.key === PROGRAM_EVALUATION_KEY || report.key === IMPLEMENTATION_KEY || report.key === LIBRARY_KEY));
  }
  return tiles;
}

export const REPORT_CATALOG: ReportCatalogEntry[] = [
  {
    key: PROGRAM_EVALUATION_KEY,
    title: 'Program Evaluation',
    description: DISTRICT_WIDE_DESCRIPTION,
    coverSrc: programEvaluationSample,
  },
  {
    key: STUDENT_PROGRESS_KEY,
    title: 'Student progress reports',
    description:
      'A printable report for each student: Flashlight Benchmark growth, skill scores, and speaking and writing samples.',
    coverSrc: studentProgressSample,
  },
  {
    key: IMPLEMENTATION_KEY,
    title: 'Implementation report',
    description:
      'Teacher and student logins, Teacher Toolbox views and Flashlight Academy progress by school and teacher, with a printable page per school.',
  },
  {
    key: LIBRARY_KEY,
    title: 'Assignment library',
    description:
      'Browse and print the prompts teachers are assigning, by school, domain and teacher, with how many students submitted and were scored.',
    feature: FEATURE_ASSIGNMENT_LIBRARY,
  },
];
